import React from "react";
import {  Form } from "react-bootstrap";
import { fontStyle } from "../../ui/constants";
import { Box } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";

class EventForTeam extends React.Component {
  render() {
    const { events, eventId, handleTeamChange } = this.props;
    const event = events?.filter((event) => event?.id === Number(eventId));
    const licenses = JSON.parse(event[0]?.license || "[]");
    return (
      <Form className="eventArea">
        <Box mb={2} className="fontStyle teamHeading">
          Select event for team
        </Box>

        <Form.Control as="select" value={eventId} onChange={handleTeamChange}>
          <option defaultValue>...</option>
          {events.map((val, k) => {
            return (
              <option key={k} id={val.id} value={val.id}>
                {val.title}
              </option>
            );
          })}
        </Form.Control>
        {eventId && licenses && licenses?.length > 0 && (
          <Box>
            <Box
              style={fontStyle}
              bgcolor="#F7F7F7"
              p={0.5}
              mt={2}
              border="1px solid #F65A5A"
            >
              <span>
                <BlockIcon />
              </span>
              Required License:{" "}
              {licenses?.map((item, index) => (
                <span
                  key={index}
                  style={{
                    color: "black",
                    fontFamily: "Segoe UI",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {item?.licenseType},
                </span>
              ))}
            </Box>
          </Box>
        )}
        <Box pt={1}> <hr /></Box>       
      </Form>
    );
  }
}

export default EventForTeam;
